import { render, staticRenderFns } from "./City.vue?vue&type=template&id=0dc5911f&scoped=true"
import script from "./City.vue?vue&type=script&lang=js"
export * from "./City.vue?vue&type=script&lang=js"
import style0 from "./City.vue?vue&type=style&index=0&id=0dc5911f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc5911f",
  null
  
)

export default component.exports